import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, putApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, AtualizarFuncionalidadeRequest } from './types';

// ACTIONS
import {
	atualizarFuncionalidadeSuccess,
	atualizarFuncionalidadeFailure,
} from './actions';

function* atualizarFuncionalidade(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: AtualizarFuncionalidadeRequest } = request;

	const body = { ...payload };

	delete body.id;
	delete body.idUsuarioAutenticado;

	const response: ApiResponse = yield call(
		putApi,
		token || '',
		PATH_SGU_API,
		`funcionalidades/${payload.id}`,
		body,
		{ idUsuarioAutenticado: payload.idUsuarioAutenticado },
	);

	if (response.status === 200) {
		yield put(atualizarFuncionalidadeSuccess(response));
	} else {
		yield put(atualizarFuncionalidadeFailure());
	}
}

export default all([
	takeLatest(Types.ATUALIZAR_FUNCIONALIDADE, atualizarFuncionalidade),
]);
